import { render } from "./index.vue?vue&type=template&id=5b204ecd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5b204ecd&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=5b204ecd&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b204ecd"],['__file',"src/views/Dashboard/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b204ecd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b204ecd', __exports__)) {
    console.log('reload')
    api.reload('5b204ecd', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5b204ecd&scoped=true", () => {
    console.log('re-render')
    api.rerender('5b204ecd', render)
  })

}


export default __exports__